import 'react-native-gesture-handler';
import 'expo-dev-client';
import { StatusBar } from 'expo-status-bar';
import React, {Component} from 'react';
import { Platform, StyleSheet, View, Text, Alert } from 'react-native';
import * as Linking from 'expo-linking';

import { Asset } from 'expo-asset';
import * as Font from 'expo-font';

import AppLoading from 'expo-app-loading';
import AppNavigator from './navigation/AppNavigator';
import FirebaseSetup, { clearAuthCookie } from './firebase/firebase_setup.js';
import FirebaseUsers from './firebase/firebase_users.js';
import FirebaseConsult from './firebase/firebase_consult.js';
import * as firebase_auth from 'firebase/auth';
import Messaging from './messaging.js';
import AsyncStorage from '@react-native-async-storage/async-storage';
import common from './common';

// Add function to create bid from tech data
const createBidFromTech = async (techData) => {
  if (!techData) return null;
  
  try {
    global.techLinkBid = {
      t_uid: techData.uid || "",
      t_name: techData.name || "",
      t_bname: techData.businessName || "",
      t_email: techData.email || "",
      t_phone: techData.phone || "",
      t_rate: techData.rate || "",
      t_stars: techData.stars || 4,
      t_ratings: techData.ratings || 0,
      t_experience: techData.experience || 8,
      t_profilePicture: techData.profilePicture || "https://www.autoteletech.com/assets/profile1.png",
      t_about: techData.about || "",
      t_specializations: techData.specializations || "",
      t_completedConsults: techData.completedConsults || "",
      t_stripeId: techData.stripeId || "",
      t_review: techData.reviews || [],
      price: techData.rate || "",
      t_testing: techData.testing || false,
    };
    
    console.log("Created global.techLinkBid from tech link:", global.techLinkBid);
    return global.techLinkBid;
  } catch (error) {
    console.log("Error creating bid from tech:", error);
    return null;
  }
};

export default class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      assetsLoaded: false,
      authLoaded: false,
    };
  }

  async parseInitialURL() {
    // Get the URL that opened the app
    const initialUrl = await Linking.getInitialURL();
    console.log("Initial URL:", initialUrl);
    
    if (initialUrl) {
      // Parse the URL to extract both query parameters and path segments
      const urlObj = new URL(initialUrl);
      
      // Extract consultation ID from query parameters
      const consultId = urlObj.searchParams.get('cid');
      
      // Extract URL slug/path from pathname
      const pathSegments = urlObj.pathname.split('/').filter(segment => segment !== '');
      const techLink = pathSegments.length > 0 ? pathSegments[pathSegments.length - 1] : null;
      
      // Store URL slug in global variable
      if (techLink && techLink !== 'index.html') {
        global.techLink = techLink;
        console.log("URL slug captured:", techLink);
      }
      
      
      // Handle tech link processing
      if (global.techLink) {
        try {
          // Initialize Firebase first if needed
          if (!global.db) {
            await FirebaseSetup.init();
          }
          
          console.log("Processing tech link:", global.techLink);
          const techData = await FirebaseUsers.getTechByLink(global.techLink);
          
          if (techData) {
            console.log("Found tech for link:", techData);
            await createBidFromTech(techData);
            if (!global.C_StartScreen) {
              global.C_StartScreen = 'C_TechInfo';
            }
          } else {
            console.log("No tech found for link:", global.techLink);
          }
          
        } catch (error) {
          console.log("Error processing tech link:", error);
        }
      }

      if (consultId) {
        console.log("Found consultation ID in URL:", consultId);
        try {
          // Initialize Firebase first if needed
          if (!global.db) {
            await FirebaseSetup.init();
          }
          
          // Try to recover the consultation session
          const recovered = await FirebaseConsult.recoverConsultationSession(consultId);
          if (recovered) {
            console.log("Successfully recovered consultation session");
            // Set appropriate start screen based on consultation status
            if (global.consult.status === "requested") {
              global.C_StartScreen = 'C_Request1';
            } else if (global.consult.status === "in progress") {
              global.C_StartScreen = 'C_Consult1';
            } else if (global.consult.status === "call ended") {
              global.C_StartScreen = 'C_Consult5';
            } else if (global.consult.status === "completed") {
              global.C_StartScreen = 'C_Consult3';
            }
            return true;
          }
        } catch (error) {
          console.log("Error recovering consultation:", error);
        }
      }
    }
    return false;
  }


  componentDidMount() {

    const params = new URLSearchParams(window.location.search);
    const side = params.get('side');
    const screen = params.get('screen');
    const action = params.get('action');
    
    global.techSide = false;
    if (side === "tech") {
      global.techSide = true;
    }

    if (screen === 'login') {
      global.T_StartScreen = 'T_Profile1';
      global.C_StartScreen = 'C_Login';
    }

    // Set global defaults
    global.user = null;
    global.consult = null;
    global.techSignup = {
      name: null,
      phone: null,
      email: null,
    };

    if (action === 'logout') {
      FirebaseSetup.init()
        .then(() => FirebaseUsers.signOut())
        .catch(() => {})
        .finally(() => {
          clearAuthCookie();
          var cleanUrl = window.location.origin + window.location.pathname
            + (side ? '?side=' + side + '&screen=login' : '?screen=login');
          window.location.replace(cleanUrl);
        });
      return;
    }
    
    // Try to recover session from URL first, then proceed with normal flow
    this.parseInitialURL().then(recoveredFromUrl => {
      if (recoveredFromUrl) {
        this.setState({ authLoaded: true });
        return;
      }
      
      // Continue with normal flow if no consultation was recovered from URL
      common.getUserData().then((data) => {
        console.log("data",data);
        if (data) {
          global.user = data.user;
          global.consult = data.consult;
          console.log("global.user",global.user);
          console.log("global.consult",global.consult);
        }
      })
      .then(() => FirebaseSetup.init())
      .then(loggedIn => {
        if (loggedIn) {

          global.T_StartScreen = 'T_Profile2';
          global.C_StartScreen = global.techLink ? 'C_TechInfo' : 'C_Profile1';

          if (global.user.name) {
            global.T_StartScreen = 'T_Home';
          }
          if (global.consult.id) {
            global.C_StartScreen = 'C_Request1';
            global.T_StartScreen = 'T_Request2';
          }
          if (global.consult.status === "in progress") {
            global.T_StartScreen = 'T_Consult1';
            global.C_StartScreen = 'C_Consult1';
          }
          if (global.consult.status === "call ended") {
            global.T_StartScreen = 'T_Consult2';
            global.C_StartScreen = 'C_Consult5';
          }
          if (global.consult.status === "completed") {
            global.C_StartScreen = 'C_Consult3';
          }
        } else if (screen !== 'login') {
          global.T_StartScreen = 'T_Profile2';
          global.C_StartScreen = global.techLink ? 'C_TechInfo' : 'C_Profile1';

          if (global.consult.id) {
            global.C_StartScreen = 'C_Request1';
          }
          if (global.consult.status === "in progress") {
            global.C_StartScreen = 'C_Consult1';
          }
          if (global.consult.status === "call ended") {
            global.C_StartScreen = 'C_Consult5';
          }
          if (global.consult.status === "completed") {
            global.C_StartScreen = 'C_Consult3';
          }
        }
      })
      .then(() => this.checkStripeCompletion())
      .then(() => {
        this.setState({ 
          authLoaded: true
        });
      })
      .catch((err) => {
        console.log("err");
        console.log(err);
      });
    });
    
    // Messaging.sendSMS("+1 817-905-0040", "test message")
    // .then((response) => {
    //   console.log("response");
    //   console.log(response);
    // });
    
    // Messaging.sendEmail("albius0@yahoo.com", "test subject", "test text", "<p class='testclass'>test html</p>")
    // .then((response) => {
    //   console.log("response: ", response);
    // });

  }


  checkStripeCompletion = async () => {
    try {
      // Only check if user has a stripeId
      if (!global.user.stripeId) {
        global.user.stripeLinked = false;
        global.user.stripeStatus = null;
        return false;
      }

      const r = await fetch('https://us-central1-eonn-teletech.cloudfunctions.net/getStripeAccountStatus', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ accountId: global.user.stripeId, testing: global.user.t_testing }),
      });
      const status = await r.json();

      console.log("checkStripeCompletion status:",status);
      global.user.stripeLinked = status.ready;
      global.user.stripeStatus = {
        ready: status.ready,
        charges_enabled: status.charges_enabled,
        payouts_enabled: status.payouts_enabled,
        details_submitted: status.details_submitted,
        currently_due: status.currently_due,
        past_due: status.past_due,
        disabled_reason: status.disabled_reason
      };
      console.log("global.user.stripeLinked",global.user.stripeLinked);
      console.log("global.user.stripeStatus",global.user.stripeStatus);

      if (global.user.stripeLinked) {
        if (!global.db) {
          await FirebaseSetup.init();
        }
        await FirebaseUsers.updateUserInfo();
      }

      return global.user.stripeLinked;
    } catch (error) {
      console.log("Error checking stripe completion:", error);
      global.user.stripeLinked = false;
      global.user.stripeStatus = null;
      return false;
    }
  }

  render() {

      if (!this.state.assetsLoaded || !this.state.authLoaded ) {
        return (
          <AppLoading
            startAsync={loadResourcesAsync}
            onError={console.warn}
            onFinish={() => this.setState({ assetsLoaded: true })}
          />
        );
      } else {
        return (
          <View style={{
            flex: 1,
            height: '100%',
            width: '100%',
          }}>
            <AppNavigator/>
            <StatusBar style="dark" />
          </View>
        );
      }
  }
}

async function loadResourcesAsync() {
  await Promise.all([
    Asset.loadAsync([
      require('./assets/images/bg1.png'),
      require('./assets/images/logo.png'),
      require('./assets/images/button1.png'),
      require('./assets/images/portrait1.png'),
      require('./assets/images/specializations/ac1.png'),
      require('./assets/images/specializations/ac1b.png'),
      require('./assets/images/specializations/brakes1.png'),
      require('./assets/images/specializations/brakes1b.png'),
      require('./assets/images/specializations/fuel1.png'),
      require('./assets/images/specializations/fuel1b.png'),
      require('./assets/images/specializations/electronics1.png'),
      require('./assets/images/specializations/electronics1b.png'),
      require('./assets/images/specializations/electrical1.png'),
      require('./assets/images/specializations/electrical1b.png'),
      require('./assets/images/specializations/engine1.png'),
      require('./assets/images/specializations/engine1b.png'),
      require('./assets/images/specializations/steering1.png'),
      require('./assets/images/specializations/steering1b.png'),
      require('./assets/images/specializations/suspension1.png'),
      require('./assets/images/specializations/suspension1b.png'),
      require('./assets/images/specializations/transmission1.png'),
      require('./assets/images/specializations/transmission1b.png'),
      require('./assets/images/star2.png'),
      require('./assets/images/star2-over.png'),
      require('./assets/images/star2-empty.png'),
    ]),
    Font.loadAsync({
      'nunito': require('./assets/fonts/NunitoSans-VariableFont_YTLC,opsz,wdth,wght.ttf'),
    }),
    Font.loadAsync({
      'nunitolight': require('./assets/fonts/NunitoSans-Light.ttf'),
    }),
  ]);
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    height: '100%',
    width: '100%',
    backgroundColor: '#fff',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
